import RecluimentView from "../RecluimentView.vue";
import JobsOpeningList from "../Pages/JobsOpeningList.vue";
import ApplicantsList from "../Pages/ApplicantsList.vue";
import JobsOpeningEditor from '../Pages/JobsOpeningEditor.vue'
import JobOpeningDetails from "../Pages/JobOpeningDetails.vue";
// import EmployeeEditor from "../Pages/EmployeeEditor.vue";

const routes = [
  {
    path: '/reclutamiento',
    component: RecluimentView,
    children: [
      {
        path: 'vacantes',
        name: 'job-openings-list',
        component: JobsOpeningList,
      },
      {
        path: 'postulantes',
        name: 'applicants-list',
        component: ApplicantsList,
      },
      {
        path: 'vacantes/crear',
        name: 'applicants-create',
        component: JobsOpeningEditor,
      },
      {
        path: 'vacantes/:id/detalle',
        name: 'applicants-list',
        component: JobOpeningDetails,
      },
      // {
      //   path: 'crear',
      //   name: 'employee-create',
      //   component: EmployeeEditor,
      // },
      // {
      //   path: ':id',
      //   name: 'employee-edit',
      //   component: EmployeeEditor,
      // },
    ]
  }
]

export default routes
